import styles from './ErrorScreen.module.css'

interface ErrorScreenProps {
  message: string
  onRetry?: () => void
}

export function ErrorScreen({ message, onRetry }: ErrorScreenProps) {
  return (
    <div className={styles.root} role="alert">
      <div className={`card ${styles.card}`}>
        <span className="microlabel">Erro ao carregar edição</span>
        <h2 className={styles.heading}>Não foi possível carregar os dados</h2>
        <p className={styles.detail}>{message}</p>
        {onRetry && (
          <button className={`btn-cta ${styles.retry}`} onClick={onRetry}>
            Tentar novamente
          </button>
        )}
      </div>
    </div>
  )
}
